export default __webpack_public_path__ + "static/media/3.13954b76.jpg";